<template>
  <div>
    <vue-table :table-data="tableData" ref="tableRef">
      <template slot="searchBar">
        <el-form-item label="厂商">
          <company-select v-model="tableData.search.company_id" clearable/>
        </el-form-item>
        <el-form-item label="型号名称">
          <el-input v-model.trim="tableData.search.name" clearable></el-input>
        </el-form-item>
      </template>
      <template slot="operateBar">
        <el-button v-if="checkApi('addModel')" size="small" type="primary" @click="add">添加型号</el-button>
      </template>
      <template v-if="hasApi(['reviseModel','deleteModel'])" slot="actionBar">
        <el-table-column align="center" label="操作栏" :resizable="false" width="120">
          <template slot-scope="{row}">
            <el-button v-if="checkApi('reviseModel')" type="text" @click="revise(row)">修改</el-button>
            <el-button v-if="checkApi('deleteModel')" type="text" class="danger" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </vue-table>
    <model-operate v-if="modelOperate.visible" :dialog-data="modelOperate" @table-reload="getTableList"/>
  </div>
</template>

<script>
  import ModelOperate from "./dialog/ModelOperate"
  import {sequenceStatus, checksumStatus} from "@utils/formatList"
  import CompanySelect from "@view/components/select/CompanySelect"
  export default {
    name: "modelManage",
    components: {ModelOperate,CompanySelect},
    data() {
      return {
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "ID", property: "id"},
            {label: "厂商", property: "company.name"},
            {label: "型号名称", property: "name"},
            {label: "LAN个数", property: "lan_number"},
            {label: "WAN个数", property: "wan_number"},
            {label: "WiFi2.4g个数", property: "wifi2g_number"},
            {label: "WiFi5g个数", property: "wifi5g_number"},
            {label: "WiFi6g个数", property: "wifi6g_number"},
            {label: "生成流水", property: "use_sequence", format: sequenceStatus},
            {label: "校验和", property: "use_checksum", format: checksumStatus},
            {label: "创建人", property: "admin.name"},
          ],
          api: "getModelList",
          search: {
            name: "",
            company_id: "",
          },
        },
        modelOperate: {visible: false, width: 400, title: "", row: null},
      }
    },
    methods: {
      add() {
        this.modelOperate.visible = true;
        this.modelOperate.title = "添加型号";
        this.modelOperate.row = null;
      },
      revise(row) {
        this.modelOperate.visible = true;
        this.modelOperate.title = "修改型号";
        const nv = {...row};
        nv.use_sequence = +nv.use_sequence;
        nv.use_checksum = +nv.use_checksum;
        this.modelOperate.row = nv;
      },
      remove(row) {
        this.openConfirm("删除该型号", async ()=> {
          let nv = {device_model_id: row.id};
          let res = await this.$Http.deleteModel(nv);
          if (res) {
            this.msgSuccess("删除成功");
            this.getTableList();
          }
        });
      },
      getTableList() {
        this.$refs["tableRef"].refresh();
      },
    },
  }
</script>

<style scoped>

</style>
